import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

export const LicensesIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 14 14">
      <path
        d="M6.66667 0C2.98667 0 0 2.98667 0 6.66667C0 10.3467 2.98667 13.3333 6.66667 13.3333C10.3467 13.3333 13.3333 10.3467 13.3333 6.66667C13.3333 2.98667 10.3467 0 6.66667 0ZM1.33333 6.66667C1.33333 6.26 1.38667 5.86 1.47333 5.48L4.66 8.66667V9.33333C4.66 10.0667 5.26 10.6667 5.99333 10.6667V11.9533C3.37333 11.62 1.33333 9.38 1.33333 6.66667ZM10.5933 10.2667C10.42 9.72667 9.92667 9.33333 9.32667 9.33333H8.66V7.33333C8.66 6.96667 8.36 6.66667 7.99333 6.66667H3.99333V5.33333H5.32667C5.69333 5.33333 5.99333 5.03333 5.99333 4.66667V3.33333H7.32667C8.06 3.33333 8.66 2.73333 8.66 2V1.72667C10.6133 2.51333 12 4.43333 12 6.66667C12 8.05333 11.46 9.32 10.5933 10.2667Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
